export default __webpack_public_path__ + "static/freshms-teaser2-tablet-183e76a60a997d0bcc3c93d563215bc0.png";